import { Person2 } from '@mui/icons-material';
import { Avatar, Box, Card, CardContent, SxProps, Typography, alpha } from '@mui/material';
import React from 'react';

const StudentDropzone = ({ isOver, sx = {} }: { isOver: boolean; sx?: SxProps }) => {
  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Card
        sx={theme => ({
          backgroundColor: isOver ? alpha(theme.palette.primary.main, 0.15) : alpha(theme.palette.primary.main, 0.05),
          border: `1px dashed ${theme.palette.primary.main}`,
        })}
      >
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '12px !important' }}>
          <Avatar sx={theme => ({ backgroundColor: alpha(theme.palette.primary.light, 0.3), height: 32, width: 32 })}>
            <Person2 color="primary" />
          </Avatar>
          <Typography color="primary">Drag student here</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default StudentDropzone;
